import React from "react";
import { toastr } from "react-redux-toastr";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import {
	FormGroup,
	FormControl,
	FormLabel,
	InputGroup,
	Nav,
	Tab,
	Collapse,
} from "react-bootstrap";
import { iPlanService } from "services";
import { errorFormating, renderErrorList } from "utils/utils";
import { convertToUTC, convertFromUTC } from "utils/datetime";
import { FaMagic } from "react-icons/fa";
import { FiX, FiInfo, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { DateRangePicker } from "react-dates";
import SubmitButton from "components/SubmitButton";
import * as groupsActions from "actions/groupsActions";
import * as calendarsActions from "actions/calendarsActions";
import Switch from "components/Switch";
import { getFirstLastInterval } from "utils/datetime";
import TimeConfigModal from "./TimeConfigModal";
import "./TimeConfigModal.scss";
import {
	isBalanceShiftsHighPriorityVisible,
	resolveBalanceShiftsHighPriority,
	withBalanceShiftsByEmployee,
} from "./planMagicBalanceShifts";

class PlanMagic extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		const magic_plan = {
			start: this.props.start || "",
			end: this.props.end || "",
			group_id: this.props.group_id || "",
			min_consecutive_workdays: {
				active: false,
				value: 0,
			},
			max_working_hours_between_restdays: {
				active: false,
				value: 0,
			},
			extra_hours_allowed: false,
			over_assign_needs: false,
			balance_working_hours: false,
			balance_shifts_by_employee: false,
			balance_shifts_by_employee_high_priority: false,
			different_weekly_shifts: {
				active: false,
				start: "",
				end: "",
			},
			different_weekly_shifts_until_friday: {
				active: false,
				start: "",
				end: "",
			},
			fraction_shifts: false,
			fraction_shifts_minutes: 0,
			concatenate_shifts_without_rests_per_day: false,
			minimum_daily_hours: {
				active: false,
				value: 0,
			},
			maximum_daily_hours: {
				active: false,
				value: 0,
			},
			min_resthours_between_workdays: {
				active: false,
				value: 0,
			},
			min_resthours_between_shifts: {
				active: false,
				value: 0,
			},
			max_resthours_between_shifts: {
				active: false,
				value: 0,
			},
			min_weekly_restdays: {
				active: false,
				value: 0,
			},
			min_consecutive_restdays: {
				active: false,
				value: 0,
			},
			min_consecutive_rest_hours: {
				active: false,
				value: 0,
			},
			max_consecutive_restdays: {
				active: false,
				value: 0,
			},
			rest_day_types: {
				active: false,
				value: [],
			},
			next_week_rest_if_shifts_assigned: {
				active: false,
				value: [],
			},
			minimum_free_weekends: {
				active: false,
				value: 0,
			},
			minimum_weekly_consecutive_rest_hours: {
				active: false,
				value: 0,
			},
			minimum_working_hours_per_block: {
				active: false,
				value: 0,
			},
			minimum_rest_hours_between_blocks: {
				active: false,
				value: 0,
			},
			number_of_blocks: {
				active: false,
				value: 0,
			},
			maximize_skills: false,
			maximize_function_priorities: false,
			minimize_shift_changes: false,
			ubiquitous_employees: false,
			timelimit: 0,
			timelimit_execution: 0,
			separated_restdays: false,
			forbid_unassigned_shifts: false,
			single_ubication_per_day: false,
			different_consecutive_shifts: false,
			single_function_per_block: false,
			single_ubication_per_block: false,
		};

		let isEdit = false;

		if (props.magic_plan) {
			magic_plan = props.magic_plan;
			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			error: "",
			error_footer: "",
			magic_plan,
			new_day_type: {},
			selected_day_types: [],
			new_shift: {},
			selected_shifts: [],
			show_time_modal: false,
			active_modal_type: null, // 'weekly' o 'friday'
			temp_time_config: {
				start: "",
				end: "",
			},
			temp_time_config_friday: {
				start: "",
				end: "",
			},
			showAdvancedOptions: false, // Para el collapse de grupo y periodo
		};
	}

	componentDidMount() {
		this.props.getSelectableDayTypes();
		this.props.getAllGroups();
	}

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;
		const { magic_plan } = this.state;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) endDate = endDate.format("YYYY-MM-DD");

		this.setState({
			magic_plan: {
				...magic_plan,
				start: startDate,
				end: endDate,
			},
		});
	};

	handleChange = (event) => {
		const { magic_plan } = this.state;

		const key = event.target.id;
		let value = event.target.value;
		value = value === "on" ? event.target.checked : value * 1;

		// console.log(key);

		if (key.indexOf(".") > -1) {
			const key_split = key.split(".");
			const key0 = key_split[0];
			const key1 = key_split[1];
			magic_plan[key0][key1] = value;
		}
		// extra_hours_allowed y over_assign_needs son excluyentes
		else if (key === "extra_hours_allowed" && value) {
			magic_plan.extra_hours_allowed = value;
			magic_plan.over_assign_needs = false;
		} else if (key === "over_assign_needs" && value) {
			magic_plan.over_assign_needs = value;
			magic_plan.extra_hours_allowed = false;
		} else if (key === "balance_shifts_by_employee") {
			Object.assign(magic_plan, withBalanceShiftsByEmployee(magic_plan, value));
		} else {
			magic_plan[key] = value;
		}

		this.setState({
			magic_plan,
		});
	};

	handleChangeFractionShifts = (event) => {
		const { magic_plan } = this.state;

		const value = event.target.value;

		if (value === "false") {
			magic_plan.fraction_shifts = false;
			magic_plan.fraction_shifts_minutes = null;
		} else if (value === "15" || value === "30" || value === "60") {
			magic_plan.fraction_shifts = true;
			magic_plan.fraction_shifts_minutes = parseInt(value);
		}

		this.setState({
			magic_plan,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	checkInvalidRange = () => {
		const { magic_plan, submitted } = this.state;
		return (
			submitted &&
			(magic_plan.start === "" ||
				magic_plan.end === "" ||
				magic_plan.start === null ||
				magic_plan.end === null)
		);
	};

	prepareDayTypesToSubmit = () => {
		const { selected_day_types } = this.state;

		return selected_day_types.map((day_type) => day_type.name);
	};

	prepareShiftsToSubmit = () => {
		const { selected_shifts } = this.state;

		return selected_shifts.map((shift) => shift.name);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });

		const { magic_plan, selected_day_types, selected_shifts } = this.state;
		const props = this.props;
		const magic_plan_to_send = { ...magic_plan };

		// prepara rest_day_types si hay tipos de día seleccionados
		if (selected_day_types.length > 0) {
			magic_plan_to_send.rest_day_types = {
				active: true,
				value: this.prepareDayTypesToSubmit(),
			};
		} else {
			magic_plan_to_send.rest_day_types = {
				active: false,
				value: [],
			};
		}

		// prepara next_week_rest_if_shifts_assigned si hay shifts seleccionados
		if (selected_shifts.length > 0) {
			magic_plan_to_send.next_week_rest_if_shifts_assigned = {
				active: true,
				value: this.prepareShiftsToSubmit(),
			};
		} else {
			magic_plan_to_send.next_week_rest_if_shifts_assigned = {
				active: false,
				value: [],
			};
		}

		magic_plan_to_send.concatenate_shifts_without_rests_per_day =
			magic_plan.fraction_shifts;
		magic_plan_to_send.balance_shifts_by_employee_high_priority =
			resolveBalanceShiftsHighPriority(magic_plan);

		if (magic_plan.timelimit <= 0) magic_plan_to_send.timelimit = null;

		// console.log(magic_plan_to_send);

		const response = await iPlanService.updateMagicPlan(magic_plan_to_send);
		// console.log(response);

		if (response.ok) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					// Cerrar el modal
					// Llamar a la función onPlanProcessing con los datos de respuesta
					if (props.onPlanProcessing) {
						props.onPlanProcessing(response);
					}
					props.handleClose();
				}
			);
		} else {
			// console.log(errorFormating(response));

			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
				error_footer: renderErrorList(response),
			});
		}
	};

	// tipos de dia para festivos

	handleAddChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	handleAddShiftChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	addDayType = () => {
		let { selected_day_types, new_day_type } = this.state;
		let isValid = true;
		let day_type;
		const errors = {};

		if (new_day_type === undefined) {
			isValid = false;
		} else {
			day_type = this.props.select_day_types.find(
				(item) => item.id === parseInt(new_day_type)
			);
			if (day_type === undefined) {
				isValid = false;
				errors.day_type = false;
			}
		}

		if (isValid) {
			// check if day already exists
			const exists = selected_day_types.find(
				(item) => item.id === parseInt(new_day_type)
			);

			if (!exists) {
				selected_day_types = selected_day_types.concat(day_type);
			}

			this.setState({
				selected_day_types,
				errors: {},
				new_day_type: {},
			});
		} else {
			this.setState({
				errors,
			});
		}
	};

	addBulkDayTypes = (start, end) => {
		const selected_day_types = [];
		const { select_day_types } = this.props;

		for (let i = start; i <= end; i++) {
			const day_type = select_day_types.find((item) => item.weekday === i);
			selected_day_types.push(day_type);
		}

		this.setState({
			selected_day_types,
			errors: {},
			new_day_type: {},
		});
	};

	removeDayType = (idDayType) => {
		this.setState((prevState, props) => ({
			selected_day_types: prevState.selected_day_types.filter(
				(item) => item.id !== parseInt(idDayType)
			),
		}));
	};

	addShift = () => {
		let { selected_shifts, new_shift } = this.state;
		let isValid = true;
		let shift;
		const errors = {};

		if (new_shift === undefined) {
			isValid = false;
		} else {
			shift = this.props.attendance_shifts.find(
				(item) => item.id === parseInt(new_shift)
			);
			if (shift === undefined) {
				isValid = false;
				errors.shift = false;
			}
		}

		if (isValid) {
			// check if shift already exists
			const exists = selected_shifts.find(
				(item) => item.id === parseInt(new_shift)
			);

			if (!exists) {
				selected_shifts = selected_shifts.concat(shift);
			}

			this.setState({
				selected_shifts,
				errors: {},
				new_shift: {},
			});
		} else {
			this.setState({
				errors,
			});
		}
	};

	removeShift = (idShift) => {
		this.setState((prevState, props) => ({
			selected_shifts: prevState.selected_shifts.filter(
				(item) => item.id !== parseInt(idShift)
			),
		}));
	};

	// Métodos para manejar el modal de configuración de horas
	handleDifferentWeeklyShiftsToggle = (event) => {
		const { magic_plan } = this.state;
		const isCurrentlyActive = magic_plan.different_weekly_shifts.active;

		if (!isCurrentlyActive) {
			// Si se está activando, abrir el modal
			this.setState({
				show_time_modal: true,
				active_modal_type: 'weekly',
				temp_time_config: {
					start: "",
					end: "",
				},
			});
		} else {
			// Si se está desactivando, simplemente cambiar el estado
			magic_plan.different_weekly_shifts.active = false;
			magic_plan.different_weekly_shifts.start = "";
			magic_plan.different_weekly_shifts.end = "";
			this.setState({ magic_plan });
		}
	};

	handleTimeConfigChange = (event) => {
		const { temp_time_config } = this.state;
		const key = event.target.id;
		const value = event.target.value;

		this.setState({
			temp_time_config: {
				...temp_time_config,
				[key]: value,
			},
		});
	};

	handleTimeModalAccept = () => {
		const { temp_time_config, magic_plan } = this.state;
		const { start, end } = temp_time_config;

		// Validar que ambas horas estén completas
		if (!start || !end) {
			toastr.error("Error", this.props.t('plan.magic.errorBothTimes'));
			return;
		}

		// Validar que la hora de inicio no sea mayor que la de fin
		if (start >= end) {
			toastr.error("Error", this.props.t('plan.magic.errorStartBeforeEnd'));
			return;
		}

		// Convertir correctamente a UTC considerando la zona horaria local
		// Replicando exactamente la lógica de ShiftEditModal.js
		const tz = moment.tz.guess();
		const base = moment().startOf('day');

		// Creamos dos moments locales con fecha "hoy"
		let mStart = base.clone().hour(+start.split(':')[0]).minute(+start.split(':')[1]);
		let mEnd = base.clone().hour(+end.split(':')[0]).minute(+end.split(':')[1]);

		// Si el fin "local" es antes del inicio → cruza medianoche → sumamos 1 día
		if (mEnd.isBefore(mStart)) {
			mEnd.add(1, 'day');
		}

		// Ahora sí los pasamos a UTC, sin cambiar de fecha de referencia
		const startUTC = mStart.tz(tz).utc().format("HH:mm[Z]");
		const endUTC = mEnd.tz(tz).utc().format("HH:mm[Z]");

		// Aplicar la configuración
		magic_plan.different_weekly_shifts.active = true;
		magic_plan.different_weekly_shifts.start = startUTC;
		magic_plan.different_weekly_shifts.end = endUTC;

		this.setState({
			magic_plan,
			show_time_modal: false,
			temp_time_config: {
				start: "",
				end: "",
			},
		});
	};

	handleTimeModalCancel = () => {
		this.setState({
			show_time_modal: false,
			active_modal_type: null,
			temp_time_config: {
				start: "",
				end: "",
			},
		});
	};

	// Métodos para manejar el modal de configuración de horas para viernes
	handleDifferentWeeklyShiftsUntilFridayToggle = (event) => {
		const { magic_plan } = this.state;
		const isCurrentlyActive = magic_plan.different_weekly_shifts_until_friday.active;

		if (!isCurrentlyActive) {
			// Si se está activando, abrir el modal
			this.setState({
				show_time_modal: true,
				active_modal_type: 'friday',
				temp_time_config_friday: {
					start: "",
					end: "",
				},
			});
		} else {
			// Si se está desactivando, simplemente cambiar el estado
			magic_plan.different_weekly_shifts_until_friday.active = false;
			magic_plan.different_weekly_shifts_until_friday.start = "";
			magic_plan.different_weekly_shifts_until_friday.end = "";
			this.setState({ magic_plan });
		}
	};

	handleTimeConfigFridayChange = (event) => {
		const { temp_time_config_friday } = this.state;
		const key = event.target.id;
		const value = event.target.value;

		this.setState({
			temp_time_config_friday: {
				...temp_time_config_friday,
				[key]: value,
			},
		});
	};

	handleTimeModalFridayAccept = () => {
		const { temp_time_config_friday, magic_plan } = this.state;
		const { start, end } = temp_time_config_friday;

		// Validar que ambas horas estén completas
		if (!start || !end) {
			toastr.error("Error", this.props.t('plan.magic.errorBothTimes'));
			return;
		}

		// Validar que la hora de inicio no sea mayor que la de fin
		if (start >= end) {
			toastr.error("Error", this.props.t('plan.magic.errorStartBeforeEnd'));
			return;
		}

		// Convertir correctamente a UTC considerando la zona horaria local
		// Replicando exactamente la lógica de ShiftEditModal.js
		const tz = moment.tz.guess();
		const base = moment().startOf('day');

		// Creamos dos moments locales con fecha "hoy"
		let mStart = base.clone().hour(+start.split(':')[0]).minute(+start.split(':')[1]);
		let mEnd = base.clone().hour(+end.split(':')[0]).minute(+end.split(':')[1]);

		// Si el fin "local" es antes del inicio → cruza medianoche → sumamos 1 día
		if (mEnd.isBefore(mStart)) {
			mEnd.add(1, 'day');
		}

		// Ahora sí los pasamos a UTC, sin cambiar de fecha de referencia
		const startUTC = mStart.tz(tz).utc().format("HH:mm[Z]");
		const endUTC = mEnd.tz(tz).utc().format("HH:mm[Z]");

		// Aplicar la configuración
		magic_plan.different_weekly_shifts_until_friday.active = true;
		magic_plan.different_weekly_shifts_until_friday.start = startUTC;
		magic_plan.different_weekly_shifts_until_friday.end = endUTC;

		this.setState({
			magic_plan,
			show_time_modal: false,
			temp_time_config_friday: {
				start: "",
				end: "",
			},
		});
	};

	handleTimeModalFridayCancel = () => {
		this.setState({
			show_time_modal: false,
			active_modal_type: null,
			temp_time_config_friday: {
				start: "",
				end: "",
			},
		});
	};

	getSelectedDayTypes = () =>
		this.state.selected_day_types.map((item) => {
			return (
				<li
					key={item.id}
					aria-label={item.description}
					title={item.description}
					className="tag-default tag-delete"
					style={{
						backgroundColor: item.background_color && item.background_color,
					}}
				>
					{item.name}
					<button
						type="button"
						onClick={() => this.removeDayType(item.id)}
						className="btn-tag-delete btn-transparent"
					>
						<FiX />
					</button>
				</li>
			);
		});

	getSelectedShifts = () =>
		this.state.selected_shifts.map((item) => {
			return (
				<li
					key={item.id}
					aria-label={item.name}
					title={item.name}
					className="tag-default tag-delete"
				>
					{item.name} {getFirstLastInterval(item.time_intervals, true)}
					<button
						type="button"
						onClick={() => this.removeShift(item.id)}
						className="btn-tag-delete btn-transparent"
					>
						<FiX />
					</button>
				</li>
			);
		});

	render() {
		const {
			magic_plan,
			error,
			new_day_type,
			new_shift,
			errors,
			group_id,
			submitted,
			selected_day_types,
			selected_shifts,
		} = this.state;
		const { detailed_groups, select_day_types, attendance_shifts } = this.props;

		const min_consecutive_workdays_active =
			magic_plan.min_consecutive_workdays.active;
		const max_working_hours_between_restdays_active =
			magic_plan.max_working_hours_between_restdays.active;
		const extra_hours_allowed = magic_plan.extra_hours_allowed;
		const balance_working_hours = magic_plan.balance_working_hours;
		const balance_shifts_by_employee = magic_plan.balance_shifts_by_employee;
		const balance_shifts_by_employee_high_priority =
			magic_plan.balance_shifts_by_employee_high_priority;
		const different_weekly_shifts = magic_plan.different_weekly_shifts.active;
		const different_weekly_shifts_until_friday = magic_plan.different_weekly_shifts_until_friday.active;
		const different_consecutive_shifts =
			magic_plan.different_consecutive_shifts;
		const over_assign_needs = magic_plan.over_assign_needs;
		const minimum_daily_hours_active = magic_plan.minimum_daily_hours.active;
		const maximum_daily_hours_active = magic_plan.maximum_daily_hours.active;
		const minimum_working_hours_per_block_active =
			magic_plan.minimum_working_hours_per_block.active;
		const minimum_rest_hours_between_blocks_active =
			magic_plan.minimum_rest_hours_between_blocks.active;
		const number_of_blocks_active = magic_plan.number_of_blocks.active;
		const min_resthours_between_workdays_active =
			magic_plan.min_resthours_between_workdays.active;
		const min_resthours_between_shifts_active =
			magic_plan.min_resthours_between_shifts.active;
		const max_resthours_between_shifts_active =
			magic_plan.max_resthours_between_shifts.active;
		const min_weekly_restdays_active = magic_plan.min_weekly_restdays.active;
		const min_consecutive_restdays_active =
			magic_plan.min_consecutive_restdays.active;
		const min_consecutive_rest_hours_active =
			magic_plan.min_consecutive_rest_hours.active;
		const minimum_free_weekends_active =
			magic_plan.minimum_free_weekends.active;
		// const concatenate_shifts_without_rests_per_day = magic_plan.concatenate_shifts_without_rests_per_day;
		const max_consecutive_restdays_active =
			magic_plan.max_consecutive_restdays.active;
		const maximize_skills = magic_plan.maximize_skills;
		const maximize_function_priorities =
			magic_plan.maximize_function_priorities;
		const minimize_shift_changes = magic_plan.minimize_shift_changes;
		const ubiquitous_employees = magic_plan.ubiquitous_employees;
		const separated_restdays = magic_plan.separated_restdays;
		const forbid_unassigned_shifts = magic_plan.forbid_unassigned_shifts;
		const single_ubication_per_day = magic_plan.single_ubication_per_day;
		const single_function_per_block = magic_plan.single_function_per_block;
		const single_ubication_per_block = magic_plan.single_ubication_per_block;
		const minimum_weekly_consecutive_rest_hours_active =
			magic_plan.minimum_weekly_consecutive_rest_hours.active;

		const optionShiftList =
			attendance_shifts.length > 0 &&
			attendance_shifts.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name} {getFirstLastInterval(item.time_intervals, true)}
					</option>
				);
			}, this);

		const optionGroupList =
			detailed_groups.length > 0 &&
			detailed_groups.map((item, i) => {
				let multigroup = item.is_multigroup ? " (multigrupo)" : "";
				return (
					<option key={i} value={item.id}>
						{item.name}
						{multigroup}
					</option>
				);
			}, this);

		const optionDayTypeList =
			select_day_types.length > 0 &&
			select_day_types.map((item, i) => {
				const label = item.description
					? item.name + " (" + item.description + ")"
					: item.name;
				return (
					<option key={i} value={item.id}>
						{label}
					</option>
				);
			}, this);

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body plan-magic-edit">
					<div className="row">

					<div className="col-md-4 plan-magic-sidebar">
					<div className="plan-magic-sidebar-content">
						<div>
							<FormGroup className="form-group" controlId="fraction_shifts">
								<FormLabel>{this.props.t('plan.magic.detailLevel')}</FormLabel>
								<FormControl
									value={magic_plan.fraction_shifts ? String(magic_plan.fraction_shifts_minutes || "false") : "false"}
									onChange={this.handleChangeFractionShifts}
									as="select"
								>
									<option value="false">{this.props.t('plan.magic.fullShifts')}</option>
									<option value="15">{this.props.t('plan.magic.fractions15')}</option>
									<option value="30">{this.props.t('plan.magic.fractions30')}</option>
									<option value="60">{this.props.t('plan.magic.fractions60')}</option>
								</FormControl>
							</FormGroup>

							<FormGroup className="form-group" controlId="timelimit_select">
								<FormLabel>{this.props.t('plan.magic.maxExecutionTime')}</FormLabel>
								<FormControl
									id="timelimit"
									value={magic_plan.timelimit || "60"}
									onChange={this.handleChange}
									isInvalid={this.checkValidField("timelimit")}
									as="select"
								>
									<option value="60">1 minuto</option>
									<option value="300">5 minutos</option>
									<option value="1800">30 minutos</option>
									<option value="3600">1 hora</option>
									<option value="7200">2 horas</option>
									<option value="43200">12 horas</option>
									<option value="86400">1 día</option>
									<option value="259200">3 días</option>
									<option value="432000">5 días</option>
								</FormControl>
							</FormGroup>


							{/* Botón para mostrar/ocultar grupo y periodo */}
							<div className="collapse-trigger" onClick={() => this.setState({ showAdvancedOptions: !this.state.showAdvancedOptions })}>
								<span>{this.props.t('plan.magic.showMoreOptions')}</span>
								{this.state.showAdvancedOptions ? <FiChevronUp /> : <FiChevronDown />}
							</div>

							<Collapse in={this.state.showAdvancedOptions}>
								<div>
									<FormGroup className="form-group" controlId="group_id">
										<FormLabel>{this.props.t('plans.form.group')}</FormLabel>
										<FormControl
											value={magic_plan.group_id}
											onChange={this.handleChange}
											isInvalid={submitted && magic_plan.group_id === ""}
											as="select"
										>
											<option value="">{this.props.t("plans.form.selectGroup")}</option>
											{optionGroupList}
										</FormControl>
										<FormControl.Feedback type="invalid">
											{this.props.t('plans.form.groupRequired')}
										</FormControl.Feedback>
									</FormGroup>


									<FormGroup
										className={`form-group form-group-periodo ${this.checkInvalidRange() ? "is-invalid" : ""
											}`}
									>
										<FormLabel>{this.props.t('plans.form.period')}</FormLabel>
										<DateRangePicker
											startDateId="startDateId"
											endDateId="endDateId"
											startDate={magic_plan.start ? moment(magic_plan.start) : null}
											endDate={magic_plan.end ? moment(magic_plan.end) : null}
											startDatePlaceholderText={this.props.t("common.periodStart")}
											endDatePlaceholderText={this.props.t("common.periodEnd")}
											onDatesChange={this.onDatesChange}
											focusedInput={this.state.focusedInput}
											hideKeyboardShortcutsPanel={true}
											isOutsideRange={() => false}
											minimumNights={0}
											onFocusChange={(focusedInput) =>
												this.setState({ focusedInput })
											}
										/>
										<FormControl
											className="hidden"
											isInvalid={this.checkInvalidRange()}
										/>

										<FormControl.Feedback type="invalid">
											{error !== "" ? error : "{this.props.t('plans.form.periodRequired')}"}
										</FormControl.Feedback>
									</FormGroup>
								</div>
							</Collapse>
						</div>

						<div className="info-note">
							<p className="info-intro">
								<FiInfo className="info-icon" /> {this.props.t("plan.magic.infoIntro")}
							</p>
							<ul>
								<li>{this.props.t('plan.magic.infoItem1')}</li>
								<li>{this.props.t('plan.magic.infoItem2')}</li>
								<li>{this.props.t('plan.magic.infoItem3')}</li>
							</ul>
						</div>
					</div>

					<div className="modal-footer plan-magic-footer-fixed">
						<button
							type="button"
							onClick={this.props.handleClose}
							className="btn btn-outline-primary"
						>{this.props.t('common.cancel')}</button>
						<SubmitButton
							type="submit"
							isLoading={this.state.isLoading}
							text={this.props.t("plan.planShortBtn")}
							className="btn-wand"
							loadingText={this.props.t("plan.magic.planning")}
							// iconAfter={<FaMagic className="icon-wand" />}
							iconBefore={<FaMagic className="icon-wand mr-2" />}
						/>
					</div>

					</div>

					<div className="col-md-8">
					<FormLabel>{this.props.t('plan.magic.constraintsConfig')}</FormLabel>

					<Tab.Container defaultActiveKey="horas" className="tabs">
						<Nav variant="tabs">
							<Nav.Item>
								<Nav.Link eventKey="horas">{this.props.t('plan.magic.tab.hours')}</Nav.Link>
							</Nav.Item>

							{magic_plan.fraction_shifts && (
								<>
									<Nav.Item>
										<Nav.Link eventKey="fracciones">
											{`Fracciones de ${magic_plan.fraction_shifts_minutes || 30} minutos`}
										</Nav.Link>
									</Nav.Item>
								</>
							)}

							<Nav.Item>
								<Nav.Link eventKey="descansos">{this.props.t('plan.magic.tab.rests')}</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="ubicaciones">{this.props.t('plan.magic.tab.ubicationsAndFunctions')}</Nav.Link>
							</Nav.Item>
						</Nav>
						<Tab.Content>
							<Tab.Pane eventKey="horas">
								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="extra_hours_allowed"
								>
									<FormLabel>{this.props.t('plan.magic.allowExtraHours')}</FormLabel>
									<Switch
										controlId="extra_hours_allowed"
										isOn={extra_hours_allowed}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="over_assign_needs"
								>
									<FormLabel>{this.props.t('plan.magic.planUntilTargetHours')}</FormLabel>
									<Switch
										controlId="over_assign_needs"
										isOn={over_assign_needs}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="balance_working_hours"
								>
									<FormLabel>{this.props.t('plan.magic.balanceWorkingHours')}</FormLabel>
									<Switch
										controlId="balance_working_hours"
										isOn={balance_working_hours}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="balance_shifts_by_employee"
								>
									<FormLabel>{this.props.t('plan.magic.balanceShifts')}</FormLabel>
									<Switch
										controlId="balance_shifts_by_employee"
										isOn={balance_shifts_by_employee}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								{isBalanceShiftsHighPriorityVisible(magic_plan) && (
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main form-row-switch--nested"
										controlId="balance_shifts_by_employee_high_priority"
									>
										<FormLabel>{this.props.t('plan.magic.balanceShiftsHighPriority')}</FormLabel>
										<Switch
											controlId="balance_shifts_by_employee_high_priority"
											isOn={balance_shifts_by_employee_high_priority}
											handleToggle={this.handleChange}
										/>
									</FormGroup>
								)}

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="different_weekly_shifts"
									>
										<FormLabel>{this.props.t('plan.magic.sameShiftWholeWeek')}</FormLabel>
										<Switch
											controlId="different_weekly_shifts"
											isOn={different_weekly_shifts}
											handleToggle={this.handleDifferentWeeklyShiftsToggle}
										/>
									</FormGroup>
									{different_weekly_shifts && magic_plan.different_weekly_shifts.start && magic_plan.different_weekly_shifts.end && (
										<FormGroup
											className="form-group form-group-input"
											controlId="different_weekly_shifts_time"
										>
											<InputGroup>
												<FormControl
													type="text"
													value={`${convertFromUTC(magic_plan.different_weekly_shifts.start)} - ${convertFromUTC(magic_plan.different_weekly_shifts.end)}`}
													readOnly
													style={{ backgroundColor: '#f8f9fa', cursor: 'default', textAlign: 'center' }}
												/>
											</InputGroup>
										</FormGroup>
									)}
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="different_weekly_shifts_until_friday"
									>
										<FormLabel>{this.props.t('plan.magic.sameShiftMonFri')}</FormLabel>
										<Switch
											controlId="different_weekly_shifts_until_friday"
											isOn={different_weekly_shifts_until_friday}
											handleToggle={this.handleDifferentWeeklyShiftsUntilFridayToggle}
										/>
									</FormGroup>
									{different_weekly_shifts_until_friday && magic_plan.different_weekly_shifts_until_friday.start && magic_plan.different_weekly_shifts_until_friday.end && (
										<FormGroup
											className="form-group form-group-input"
											controlId="different_weekly_shifts_until_friday_time"
										>
											<InputGroup>
												<FormControl
													type="text"
													value={`${convertFromUTC(magic_plan.different_weekly_shifts_until_friday.start)} - ${convertFromUTC(magic_plan.different_weekly_shifts_until_friday.end)}`}
													readOnly
													style={{ backgroundColor: '#f8f9fa', cursor: 'default', textAlign: 'center' }}
												/>
											</InputGroup>
										</FormGroup>
									)}
								</div>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="different_consecutive_shifts"
								>
									<FormLabel>{this.props.t('plan.magic.noConsecutiveDifferentShifts')}</FormLabel>
									<Switch
										controlId="different_consecutive_shifts"
										isOn={different_consecutive_shifts}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="minimize_shift_changes"
								>
									<FormLabel>{this.props.t('plan.magic.minimizeShiftChanges')}</FormLabel>
									<Switch
										controlId="minimize_shift_changes"
										isOn={minimize_shift_changes}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="min_consecutive_workdays.active"
									>
										<FormLabel>{this.props.t('plan.magic.minConsecutiveWorkdays')}</FormLabel>
										<Switch
											controlId="min_consecutive_workdays.active"
											isOn={min_consecutive_workdays_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>
									<FormGroup
										className="form-group form-group-input"
										controlId="min_consecutive_workdays.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"min_consecutive_workdays.value"
												)}
												disabled={!min_consecutive_workdays_active}
											/>

											<InputGroup.Text>días</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="max_working_hours_between_restdays.active"
									>
										<FormLabel>{this.props.t('plan.magic.maxHoursBetweenRestdays')}</FormLabel>
										<Switch
											controlId="max_working_hours_between_restdays.active"
											isOn={max_working_hours_between_restdays_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>
									<FormGroup
										className="form-group form-group-input"
										controlId="max_working_hours_between_restdays.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"max_working_hours_between_restdays.value"
												)}
												disabled={!max_working_hours_between_restdays_active}
											/>

											<InputGroup.Text>horas</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="minimum_daily_hours.active"
									>
										<FormLabel>{this.props.t('plan.magic.minDailyHours')}</FormLabel>
										<Switch
											controlId="minimum_daily_hours.active"
											isOn={minimum_daily_hours_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="minimum_daily_hours.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"minimum_daily_hours.value"
												)}
												disabled={!minimum_daily_hours_active}
											/>

											<InputGroup.Text>horas</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="maximum_daily_hours.active"
									>
										<FormLabel>{this.props.t('plan.magic.maxDailyHours')}</FormLabel>
										<Switch
											controlId="maximum_daily_hours.active"
											isOn={maximum_daily_hours_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="maximum_daily_hours.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"maximum_daily_hours.value"
												)}
												disabled={!maximum_daily_hours_active}
											/>

											<InputGroup.Text>horas</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>
							</Tab.Pane>

							{magic_plan.fraction_shifts && (
								<>
									<Tab.Pane eventKey="fracciones" className="plan-fracciones">
										<FormGroup
											controlId="default_fractioned_shift_id"
											className="form-group form-group-flex form-row-select form-group-main"
										>
											<FormLabel>{this.props.t('plan.magic.defaultShift')}</FormLabel>
											<FormControl
												value={magic_plan.default_fractioned_shift_id}
												onChange={this.handleChange}
												placeholder={this.props.t("plan.magic.selectShift")}
												isInvalid={this.checkValidField(
													"default_fractioned_shift_id"
												)}
												as="select"
											>
												<option value="">{this.props.t('plan.magic.selectShift')}</option>
												{optionShiftList}
											</FormControl>
											<FormControl.Feedback type="invalid">
												{errors.default_fractioned_shift_id}
											</FormControl.Feedback>
										</FormGroup>

										{/* <FormGroup className="form-group"
										className="form-group-flex form-row-switch form-group-main"
										controlId="concatenate_shifts_without_rests_per_day"
									>
										<FormLabel>
											No permitir descansos dentro de un turno
										</FormLabel>
										<Switch
											controlId="concatenate_shifts_without_rests_per_day"
											isOn={concatenate_shifts_without_rests_per_day}
											handleToggle={this.handleChange}
										/>
									</FormGroup> */}

										<div className="switch-input-row">
											<FormGroup
												className="form-group form-group-flex form-row-switch form-group-main"
												controlId="minimum_working_hours_per_block.active"
											>
												<FormLabel>{this.props.t('plan.magic.minHoursPerBlock')}</FormLabel>
												<Switch
													controlId="minimum_working_hours_per_block.active"
													isOn={minimum_working_hours_per_block_active}
													handleToggle={this.handleChange}
												/>
											</FormGroup>

											<FormGroup
												className="form-group form-group-input"
												controlId="minimum_working_hours_per_block.value"
											>
												<InputGroup>
													<FormControl
														type="text"
														onChange={this.handleChange}
														placeholder="0"
														isInvalid={this.checkValidField(
															"minimum_working_hours_per_block.value"
														)}
														disabled={!minimum_working_hours_per_block_active}
													/>

													<InputGroup.Text>horas</InputGroup.Text>
												</InputGroup>
											</FormGroup>
										</div>

										<div className="switch-input-row">
											<FormGroup
												className="form-group form-group-flex form-row-switch form-group-main"
												controlId="minimum_rest_hours_between_blocks.active"
											>
												<FormLabel>{this.props.t('plan.magic.minRestBetweenBlocks')}</FormLabel>
												<Switch
													controlId="minimum_rest_hours_between_blocks.active"
													isOn={minimum_rest_hours_between_blocks_active}
													handleToggle={this.handleChange}
												/>
											</FormGroup>

											<FormGroup
												className="form-group form-group-input"
												controlId="minimum_rest_hours_between_blocks.value"
											>
												<InputGroup>
													<FormControl
														type="text"
														onChange={this.handleChange}
														placeholder="0"
														isInvalid={this.checkValidField(
															"minimum_rest_hours_between_blocks.value"
														)}
														disabled={!minimum_rest_hours_between_blocks_active}
													/>

													<InputGroup.Text>horas</InputGroup.Text>
												</InputGroup>
											</FormGroup>
										</div>

										<div className="switch-input-row">
											<FormGroup
												className="form-group form-group-flex form-row-switch form-group-main"
												controlId="number_of_blocks.active"
											>
												<FormLabel>{this.props.t('plan.magic.maxWorkBlocks')}</FormLabel>
												<Switch
													controlId="number_of_blocks.active"
													isOn={number_of_blocks_active}
													handleToggle={this.handleChange}
												/>
											</FormGroup>

											<FormGroup
												className="form-group form-group-input"
												controlId="number_of_blocks.value"
											>
												<InputGroup>
													<FormControl
														type="text"
														onChange={this.handleChange}
														placeholder="0"
														isInvalid={this.checkValidField(
															"number_of_blocks.value"
														)}
														disabled={!number_of_blocks_active}
													/>

													<InputGroup.Text
														style={{
															width: "72px",
															paddingLeft: "6px",
															paddingRight: "6px",
														}}
													>
														bloques
													</InputGroup.Text>
												</InputGroup>
											</FormGroup>
										</div>

										<FormGroup
											className="form-group form-group-flex form-row-switch form-group-main"
											controlId="single_function_per_block"
										>
											<FormLabel>{this.props.t('plan.magic.singleFunctionPerBlock')}</FormLabel>
											<Switch
												controlId="single_function_per_block"
												isOn={single_function_per_block}
												handleToggle={this.handleChange}
											/>
										</FormGroup>


										<FormGroup
											className="form-group form-group-flex form-row-switch form-group-main"
											controlId="single_ubication_per_block"
										>
											<FormLabel>{this.props.t('plan.magic.singleUbicationPerBlock')}</FormLabel>
											<Switch
												controlId="single_ubication_per_block"
												isOn={single_ubication_per_block}
												handleToggle={this.handleChange}
											/>
										</FormGroup>
									</Tab.Pane>
								</>
							)}

							<Tab.Pane eventKey="descansos" className="plan-rules">
								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="min_resthours_between_workdays.active"
									>
										<FormLabel>{this.props.t('plan.magic.minRestBetweenWorkdays')}</FormLabel>
										<Switch
											controlId="min_resthours_between_workdays.active"
											isOn={min_resthours_between_workdays_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>
									<FormGroup
										className="form-group form-group-input"
										controlId="min_resthours_between_workdays.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"min_resthours_between_workdays.value"
												)}
												disabled={!min_resthours_between_workdays_active}
											/>

											<InputGroup.Text>horas</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								{!magic_plan.fraction_shifts && (
									<>
										<div className="switch-input-row">
											<FormGroup
												className="form-group form-group-flex form-row-switch form-group-main"
												controlId="min_resthours_between_shifts.active"
											>
												<FormLabel>{this.props.t('plan.magic.minRestBetweenShifts')}</FormLabel>
												<Switch
													controlId="min_resthours_between_shifts.active"
													isOn={min_resthours_between_shifts_active}
													handleToggle={this.handleChange}
												/>
											</FormGroup>

											<FormGroup
												className="form-group form-group-input"
												controlId="min_resthours_between_shifts.value"
											>
												<InputGroup>
													<FormControl
														type="text"
														onChange={this.handleChange}
														placeholder="0"
														isInvalid={this.checkValidField(
															"min_resthours_between_shifts.value"
														)}
														disabled={!min_resthours_between_shifts_active}
													/>

													<InputGroup.Text>horas</InputGroup.Text>
												</InputGroup>
											</FormGroup>
										</div>

										<div className="switch-input-row">
											<FormGroup
												className="form-group form-group-flex form-row-switch form-group-main"
												controlId="max_resthours_between_shifts.active"
											>
												<FormLabel>{this.props.t('plan.magic.maxRestBetweenShifts')}</FormLabel>
												<Switch
													controlId="max_resthours_between_shifts.active"
													isOn={max_resthours_between_shifts_active}
													handleToggle={this.handleChange}
												/>
											</FormGroup>

											<FormGroup
												className="form-group form-group-input"
												controlId="max_resthours_between_shifts.value"
											>
												<InputGroup>
													<FormControl
														type="text"
														onChange={this.handleChange}
														placeholder="0"
														isInvalid={this.checkValidField(
															"max_resthours_between_shifts.value"
														)}
														disabled={!max_resthours_between_shifts_active}
													/>
													<InputGroup.Text>horas</InputGroup.Text>
												</InputGroup>
											</FormGroup>
										</div>
									</>
								)}

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="separated_restdays"
								>
									<FormLabel>{this.props.t('plan.magic.separatedRestdays')}</FormLabel>
									<Switch
										controlId="separated_restdays"
										isOn={separated_restdays}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="min_weekly_restdays.active"
									>
										<FormLabel>{this.props.t('plan.magic.minWeeklyRestdays')}</FormLabel>
										<Switch
											controlId="min_weekly_restdays.active"
											isOn={min_weekly_restdays_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="min_weekly_restdays.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"min_weekly_restdays.value"
												)}
												disabled={!min_weekly_restdays_active}
											/>

											<InputGroup.Text>días</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="minimum_weekly_consecutive_rest_hours.active"
									>
										<FormLabel>{this.props.t('plan.magic.minWeeklyConsecutiveRestHours')}</FormLabel>
										<Switch
											controlId="minimum_weekly_consecutive_rest_hours.active"
											isOn={minimum_weekly_consecutive_rest_hours_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="minimum_weekly_consecutive_rest_hours.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"minimum_weekly_consecutive_rest_hours.value"
												)}
												disabled={!minimum_weekly_consecutive_rest_hours_active}
											/>

											<InputGroup.Text>horas</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="minimum_free_weekends.active"
									>
										<FormLabel>{this.props.t('plan.magic.minFreeWeekends')}</FormLabel>
										<Switch
											controlId="minimum_free_weekends.active"
											isOn={minimum_free_weekends_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="minimum_free_weekends.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"minimum_free_weekends.value"
												)}
												disabled={!minimum_free_weekends_active}
											/>

											<InputGroup.Text>findes</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="min_consecutive_restdays.active"
									>
										<FormLabel>{this.props.t('plan.magic.minConsecutiveRestdays')}</FormLabel>
										<Switch
											controlId="min_consecutive_restdays.active"
											isOn={min_consecutive_restdays_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="min_consecutive_restdays.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"min_consecutive_restdays.value"
												)}
												disabled={!min_consecutive_restdays_active}
											/>

											<InputGroup.Text>días</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="min_consecutive_rest_hours.active"
									>
										<FormLabel>{this.props.t('plan.magic.minConsecutiveRestHours')}</FormLabel>
										<Switch
											controlId="min_consecutive_rest_hours.active"
											isOn={min_consecutive_rest_hours_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="min_consecutive_rest_hours.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"min_consecutive_rest_hours.value"
												)}
												disabled={!min_consecutive_rest_hours_active}
											/>

											<InputGroup.Text>horas</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="switch-input-row">
									<FormGroup
										className="form-group form-group-flex form-row-switch form-group-main"
										controlId="max_consecutive_restdays.active"
									>
										<FormLabel>{this.props.t('plan.magic.maxConsecutiveRestdays')}</FormLabel>
										<Switch
											controlId="max_consecutive_restdays.active"
											isOn={max_consecutive_restdays_active}
											handleToggle={this.handleChange}
										/>
									</FormGroup>

									<FormGroup
										className="form-group form-group-input"
										controlId="max_consecutive_restdays.value"
									>
										<InputGroup>
											<FormControl
												type="text"
												onChange={this.handleChange}
												placeholder="0"
												isInvalid={this.checkValidField(
													"max_consecutive_restdays.value"
												)}
												disabled={!max_consecutive_restdays_active}
											/>

											<InputGroup.Text>días</InputGroup.Text>
										</InputGroup>
									</FormGroup>
								</div>

								<div className="row-adding">
									<FormGroup
										className="form-group form-group-flex"
										controlId="new_day_type"
									>
										<FormLabel>{this.props.t('plan.magic.allowedDayTypes')}</FormLabel>

										<div className="form-box-wrap">
											<div className="form-box mw-315">
												<FormControl
													onChange={this.handleAddChange}
													value={new_day_type}
													placeholder={this.props.t("plan.magic.selectDayType")}
													isInvalid={this.checkValidField("day_type_ids")}
													as="select"
												>
													<option value="">{this.props.t("plan.magic.selectDayType")}</option>
													{optionDayTypeList}
												</FormControl>
												<FormControl.Feedback type="invalid">
													{errors.day_type_ids}
												</FormControl.Feedback>

												{selected_day_types.length === 0 ? (
													<div className="row-adding-help">
														<button
															className="btn-link"
															onClick={() => this.addBulkDayTypes(1, 5)}
														>{this.props.t('plan.magic.addMonFri')}</button>
														<button
															className="btn-link"
															onClick={() => this.addBulkDayTypes(1, 7)}
														>{this.props.t('plan.magic.addMonSun')}</button>
													</div>
												) : (
													<ul className="list-tags">
														{this.getSelectedDayTypes()}
													</ul>
												)}
											</div>
											<button
												type="button"
												onClick={this.addDayType}
												className="btn btn-primary"
											>{this.props.t('common.add')}</button>
										</div>
									</FormGroup>
								</div>

								<div className="row-adding">
									<FormGroup
										className="form-group form-group-flex"
										controlId="new_shift"
									>
										<FormLabel>{this.props.t('plan.magic.restNextWeekIfShifts')}</FormLabel>

										<div className="form-box-wrap">
											<div className="form-box mw-315">
												<FormControl
													onChange={this.handleAddShiftChange}
													value={new_shift}
													placeholder={this.props.t("plan.magic.selectShift")}
													isInvalid={this.checkValidField("shift_ids")}
													as="select"
												>
													<option value="">{this.props.t("plan.magic.selectShift")}</option>
													{optionShiftList}
												</FormControl>
												<FormControl.Feedback type="invalid">
													{errors.shift_ids}
												</FormControl.Feedback>

												{selected_shifts.length !== 0 && (

													<ul className="list-tags">
														{this.getSelectedShifts()}
													</ul>
												)}
											</div>
											<button
												type="button"
												onClick={this.addShift}
												className="btn btn-primary"
											>{this.props.t('common.add')}</button>
										</div>
									</FormGroup>
								</div>
							</Tab.Pane>
							<Tab.Pane eventKey="ubicaciones" className="plan-ubications">
							<h6>{this.props.t('plan.magic.tab.ubications')}</h6>
								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="maximize_skills"
								>
									<FormLabel>{this.props.t('plan.magic.maximizeSkills')}</FormLabel>
									<Switch
										controlId="maximize_skills"
										isOn={maximize_skills}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="ubiquitous_employees"
								>
									<FormLabel>{this.props.t('plan.magic.multipleUbications')}</FormLabel>
									<Switch
										controlId="ubiquitous_employees"
										isOn={ubiquitous_employees}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="single_ubication_per_day"
								>
									<FormLabel>{this.props.t('plan.magic.singleUbicationPerDay')}</FormLabel>
									<Switch
										controlId="single_ubication_per_day"
										isOn={single_ubication_per_day}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<h6>{this.props.t('plan.magic.tab.functions')}</h6>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="maximize_function_priorities"
								>
									<FormLabel>{this.props.t('plan.magic.maximizeFunctionPriorities')}</FormLabel>
									<Switch
										controlId="maximize_function_priorities"
										isOn={maximize_function_priorities}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

								<FormGroup
									className="form-group form-group-flex form-row-switch form-group-main"
									controlId="forbid_unassigned_shifts"
								>
									<FormLabel>{this.props.t('plan.magic.forbidUnassignedShifts')}</FormLabel>
									<Switch
										controlId="forbid_unassigned_shifts"
										isOn={forbid_unassigned_shifts}
										handleToggle={this.handleChange}
									/>
								</FormGroup>

							</Tab.Pane>
						</Tab.Content>
					</Tab.Container>

					</div>
					</div>
				


					{this.state.error_footer && this.state.error_footer}

					{/* {this.state.errors && this.state.errors.plan_id && (
						<div
							className="alert alert-danger alert-general-error fade show"
							role="alert"
						>
							{this.state.errors.plan_id}
						</div>
					)} */}
				</div>

				{/* Modal para configurar horas de turnos semanales */}
				<TimeConfigModal
					isOpen={this.state.show_time_modal && this.state.active_modal_type === 'weekly'}
					onClose={this.handleTimeModalCancel}
					onAccept={this.handleTimeModalAccept}
					tempTimeConfig={this.state.temp_time_config}
					onTimeChange={this.handleTimeConfigChange}
					title={this.props.t("plan.magic.sameShiftWholeWeek")}
				/>

				{/* Modal para configurar horas de turnos de viernes */}
				<TimeConfigModal
					isOpen={this.state.show_time_modal && this.state.active_modal_type === 'friday'}
					onClose={this.handleTimeModalFridayCancel}
					onAccept={this.handleTimeModalFridayAccept}
					tempTimeConfig={this.state.temp_time_config_friday}
					onTimeChange={this.handleTimeConfigFridayChange}
					title={this.props.t("plan.magic.sameShiftMonFri")}
				/>

				
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		...reducers.calendarsReducer,
		...reducers.shiftsReducer,
		loading: reducers.groupsReducer.loading,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAllGroups: () =>
		dispatch(
			groupsActions.getAllGroups({ sort: "+name", variant: "detailed" })
		),
	getSelectableDayTypes: () =>
		dispatch(calendarsActions.getSelectableDayTypes()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withTranslation()(PlanMagic)));
